import React from 'react'
import './NotificationsBadge.less'
import NotificationBadge, {Effect} from 'react-notification-badge'
import Icon from '../Icon'

class NotificationsBadge extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      count: props.count,
      envelopeOpen: this.props.envelopeOpen
    }
  }
  handleClick = () => {
    if (this.props.onClick) {
      this.props.onClick()
    }
    this.setState({envelopeOpen: !this.state.envelopeOpen})
  }

  componentWillReceiveProps (props) {
    this.setState({count: props.count, envelopeOpen: props.envelopeOpen})
  }

  render () {
    return (
      <div
        className={`infra-message-center-envelope ${this.state.envelopeOpen ? 'infra-message-center-envelope-selected' : ''}`}
        onClick={this.handleClick}>
        <Icon name={this.props.iconName} size='large' />
        <NotificationBadge
          className={`infra-message-center-notification-number ${this.state.count > 9 ? 'wide ' : ''}`}
          count={this.state.count}
          effect={Effect.SCALE}
          frameLength={8.0} />
      </div>
    )
  }
}
export default NotificationsBadge



// WEBPACK FOOTER //
// ../~/@master/webinfra-frontend-components/src/components/NotificationsBadge/index.js